module.exports = __webpack_public_path__ + "static/media/S4N10.f22fde13.svg";